import { useTranslation } from "../hooks/useTranslation";
import { useElementPosition } from "../hooks/useElementPosition";

export const FloatingButton = ({ href }) => {
  const { t } = useTranslation();
  const [ref, position] = useElementPosition();

  const colorchange = () => {
    const colors = ["#eeeeee", "#a5e7ff", "#debced", "#ccedc0", "#ffe7aa"];

    const gap = position.pageHeight / colors.length;

    const percentage = (gap * 100) / position.pageHeight;
    Object.keys(colors).map((key) => {
      if (position.top * key > gap * key) {
        return colors[key];
      }
    });
  };

  return (
    <a
      ref={ref}
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`${
        position.top > 20 ? " scrolled " : ""
      } floatingButton button`}
      style={{ backgroundColor: colorchange() }}
    >
      {t("buyticket")}
    </a>
  );
};
